require('./addCampaignsDialog.less');
import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');


class AddCampaignsDialog {
    activeLine;
    activeYear;
    allCampaigns;
    campaigns;

    constructor(private $mdDialog, private Campaigns, private toastService, private DistributionKeys, private LinkCampaigns){
    }

    $onInit(){
        if(this.activeLine.code === 'SALES_LAST_YEAR'){
            this.activeYear = this.activeYear - 1;
        }
        this.Campaigns.getCampaigns().$promise.then((result) => {
            this.allCampaigns = result;
            this.campaigns = this.activeLine.campaigns;
        }, (error) => {
            this.toastService.parseError(error);
        });
    };

    save (){
        this.LinkCampaigns.linkCampaigns({articleNo: this.activeLine.articleNo, id: _.map(this.campaigns, 'id').join(", "), year: this.activeYear}, {}).$promise.then(() => {
            this.activeLine.campaigns = this.campaigns;
            this.hide();
        }, (error) => {
            this.toastService.parseError(error);
        });
    };

    hide () {
        this.$mdDialog.hide();
    };

    cancel () {
        this.$mdDialog.cancel();
    };

}

class AddCampaignsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "addCampaignsDialogController";
    public template: any = require('./addCampaignsDialog.html');
    bindings: any = {
        activeLine:'=',
        activeYear:'='
    };

}

rkcApp.controller("addCampaignsDialogController", ['$mdDialog', 'Campaigns', 'toastService', 'DistributionKeys', 'LinkCampaigns', function ($mdDialog, Campaigns, toastService, DistributionKeys, LinkCampaigns) {
    return new AddCampaignsDialog($mdDialog, Campaigns, toastService, DistributionKeys, LinkCampaigns);
}])
    .component("addCampaignsDialog", new AddCampaignsOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/addCampaignsDialog/addCampaignsDialog.ts
 **/